export enum TagType {
  DIV = 0,
  PARAGRAPH,
}
